import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IToastOption {
	customToastId?: string;
  isShowClose?: boolean;
  isSnackbar?: boolean; // 스낵바 스타일
  link?: {
    text: string;
    url: string;
    target?: "_blank" | "_self" | "_parent" | "_top";
  };
  bottomPosition?: number;
  removeTime?: number;
  icon?: {
    name: string;
    size?: number;
  }
}

export interface IToast extends IToastOption {
  id: number|string;
  type: "success" | "error";
  message: string | JSX.Element;
}

const initialState: { toasts: IToast[] } = {
  toasts: [],
};

let toastId = 0;

// 중복된 toast id가 있는지 확인
// 비지니스 로직이 리듀서에 있음.. 나중에 기능 고도화 필요하면 분리하자
const duplicateToastId = (toasts: IToast[], id: number) => {
	return toasts.some((toast: IToast) => id === toast.id);
}
const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showSuccessToast(state, action) {
			const id = action.payload.customToastId || toastId++;
			duplicateToastId(state.toasts, id) 
				? console.error("toast id is duplicated")
				: state.toasts.push({ id: id, type: "success", ...action.payload });
    },
    showErrorToast(state, action) {
			const id = action.payload.customToastId || toastId++;
			duplicateToastId(state.toasts, id)
				? console.error("toast id is duplicated")
				: state.toasts.push({ id: id, type: "error", ...action.payload });
    },
    removeToast(state, action) {
      state.toasts = state.toasts.filter((toast: IToast) => toast.id !== action.payload);
    },
    clearToasts(state) {
      state.toasts = [];
    },
  },
});

export const { showSuccessToast, showErrorToast, removeToast, clearToasts } = toastSlice.actions;
export const toastData = (state: RootState) => state.toast;
export default toastSlice.reducer;
